import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppService } from '../../../app.service';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClientLandingPageService {

  constructor(private http: HttpClient) {}

  getClientLandingDtls(url: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };
    return this.http.post<any>(url, '', httpOptions);
  }

  downloadClientLogo(adminApiUrl: string, clientKey: string): Observable<Blob> {
    return this.http.get(`${adminApiUrl}/downloadClientLogo/${clientKey}`, {
      responseType: 'blob',
      withCredentials: true
    });
  }

  /**
   * Mirrors the original AngularJS clientLadingFactory.landingPage():
   * 1. Fetches fresh user navigator menu
   * 2. Updates AppService.USER_MENU
   * 3. Navigates to target route
   * 4. Reloads the page so the app re-bootstraps with the new client context
   */
  landingPage(route: string, appService: AppService, router: Router): void {
    this.http.get(environment.base_url + '/getUserNavigator').subscribe(
      (menuData: any) => {
        if (menuData && Array.isArray(menuData) && menuData.length > 0) {
          appService.USER_MENU = menuData;
        }
        const clientKey = sessionStorage.getItem('client_key') || '';
        router.navigate([route], {
          queryParams: { client_key: clientKey },
          queryParamsHandling: 'merge'
        }).then(() => {
          location.reload();
        });
      },
      () => {
        const clientKey = sessionStorage.getItem('client_key') || '';
        router.navigate([route], {
          queryParams: { client_key: clientKey },
          queryParamsHandling: 'merge'
        }).then(() => {
          location.reload();
        });
      }
    );
  }
}
